import PropTypes from 'prop-types';
import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const RequireAuth = ({ children }) => {
  const { user, isLoading } = useContext(AuthContext);
  const location = useLocation();
  if (isLoading) {
    return null;
  }
  return user ? (
    children
  ) : (
    <Navigate replace state={{ from: location }} to="/sign-in" />
  );
};

RequireAuth.propTypes = {
  children: PropTypes.any,
};

export default RequireAuth;
